import styled from 'styled-components';

export const ServicesContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #f9f9f9;
    padding: 100px 0;
    
    @media screen and (max-width: 768px) {
        padding: 50px 0;
    }
`

export const ServicesWrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    align-items: center;
    grid-gap: 20px;
    padding: 0 50px;

    @media screen and (max-width: 1000px) {
        grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 0 20px;
    }
`

export const ServicesCard = styled.div`
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 10px;
    max-height: 480px;
    height: 100%;
    padding: 30px;
    box-shadow: 0 1px 15px rgba(0,0,0,0.1);
    transition: all 0.2s ease-in-out;

    &:hover {
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }
`

export const ServicesIcon = styled.img`
    height: 160px;
    width: 100%;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 20px;
`

export const ServicesH1 = styled.h1`
    font-size: 3rem;
    color: #000;
    margin-bottom: 64px;
    position: relative;
    padding-bottom: 15px;

    &::after {
        content: '';
        position: absolute;
        width: 60px;
        height: 3px;
        background: #F54748;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
    }

    @media screen and (max-width: 480px) {
        font-size: 2rem;
    }
`

export const ServicesH2 = styled.h2`
    font-size: 1.4rem;
    font-weight: 700;
    margin-bottom: 10px;
    color: #333;
    text-align: center;
`

export const ServicesP = styled.p`
    font-size: 1.1rem;
    text-align: center;
    color: #555;
    line-height: 1.6;
`
